export default __webpack_public_path__ + "static/single-post-bg-c618efb06441e4b265aca6c86c81ed4b.png";